export const PAGE_URI = `favorites/`;
